import { ADD_LEADS_NOTE_REQUEST, ADD_LEADS_NOTE_REQUEST_SUCCESS, ADD_LEADS_NOTE_REQUEST_FAILURE } from '../constants/add_note.constants';

export const addNoteRequest = (_id, note) => ({ type: ADD_LEADS_NOTE_REQUEST, _id, note });
export const addNoteRequestSuccess = payload => ({ type: ADD_LEADS_NOTE_REQUEST_SUCCESS, payload });
export const addNoteRequestFailure = error => ({ type: ADD_LEADS_NOTE_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/add_note.actions.js